import React from "react";
import { useHistory } from "react-router-dom";
import ROUTES from "../../utils/routes";
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { 
    encodeNumber as nToString
}   from "../../API/request";

const Stage = ({type,title,description,image,idCollection}) => {
    let history = useHistory()

    const handleClick = () => {
        history.push( ROUTES.COLLECTIONSEMPTY + nToString(idCollection) );
    }

    return (
        <>
            <div 
                className="row stage"
            >
                <div className="stage__info col-md-7">
                    <h3>{type}</h3>
                    <span>{title}</span>
                    <p>{description}</p>
                    <button onClick={handleClick}>Conocer más</button>
                </div>
                <div className="stage__image col-md-5">
                    <LazyLoadImage
                        alt={image}
                        src={process.env.REACT_APP_IMAGE_PATH + image}
                    />
                </div>
            </div>
        </>
    );
};

export default Stage;